module.exports = __webpack_public_path__ + "img/Abfahrk_checkliste.68ae8b38.svg";